<template>
  <b-modal
      id="modalNF"
      ref="modalNF"
      title="Detalhes das Notas Fiscais"
      :visible="visible"
      @hide="resetModal"
      size="lg"
      scrollable
  >
    <b-card>
      <b-card-header>
        <h5>Notas Fiscais</h5>
      </b-card-header>
      <b-card-body>
        <b-table
            :items="notasFiscais"
            :fields="fields"
            striped
            responsive
        >
          <template #cell(visualizar)="data">
            <b-button
                size="sm"
                variant="outline-primary"
                @click="carregarNf(data.item)"
            >
              Visualizar
            </b-button>
          </template>
          <template #cell(show_details)="row">
            <b-form-checkbox
                v-model="row.detailsShowing"
                plain
                class="vs-checkbox-con"
                @change="row.toggleDetails"
            >
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check" />
            </span>
          </span>
              <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
            </b-form-checkbox>
          </template>

          <template #row-details="row">

            <b-card>
              <b-row class="mb-2">
               <b-table
                   :items="row.item.itens"
                   :fields="subFields"
                   striped
                   responsive
                />
              </b-row>

              <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
              >
                Hide Details
              </b-button>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>

      </b-card-body>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BModal, BCard, BCardHeader, BCardBody, BTable, BButton,
} from 'bootstrap-vue';
import DocumentoFiscalClient, { abrirPdfNovaAba } from '@/api/SistemaDKP/documento-fiscal.client';

export default {
  components: {
    BModal,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
  },
  data() {
    return {
      visible: false,
      fields: [
        'Mostrar',
        { key: 'clienteRazaoSocial', label: 'Cliente' },
        { key: 'numeroNota', label: 'Nota Fiscal' },
        { key: 'numeroSerie', label: 'Numero Serie' },
        // { key: 'visualizar', label: 'Visualizar' }
      ],
      subFields: [
        { key: 'itemid', label: 'Código do Produto' },
        { key: 'pedidoitemquantidade', label: 'Quantidade' },
        { key: 'pedidoitemprecotabela', label: 'Preço' },
        { key: 'pedidoitemtotalmercadoria', label: 'Total' },
        // Adicione outros campos se necessário
      ],
      notasFiscais: [],
    };
  },
  methods: {
    showModal(data) {
      this.visible = true;
      this.notasFiscais = data;
    },
    async carregarNf(json) {
      try {
        const item = json.item;
        const document = await new DocumentoFiscalClient().danfeBoleto({
          estabelecimentoid: item.estabelecimentoid,
          notafiscalnumero: item.notafiscalnumero || item.numeroNota,
          notafiscalserie: item.notafiscalserie || item.numeroSerie,
        });
        if (!document?.arquivoPDF) throw new Error('O ERP não retornou PDF para esta nota fiscal.');
        abrirPdfNovaAba(document.arquivoPDF);
      } catch (error) {
        console.error('Erro ao fazer a solicitação:', error);
        const text = error?.response?.data?.message || error.message || 'Não foi possível buscar o documento.';
        const indisponivel = text === 'O ERP não retornou documentos para esta nota fiscal.';
        this.$swal({ icon: indisponivel ? 'warning' : 'error', title: indisponivel ? 'Documento indisponível' : 'Erro ao abrir DANFE', text });
      }
    },

    resetModal() {
      this.visible = false;
      this.notasFiscais = [];
    },
  },
};
</script>

<style scoped>
/* Adicione estilos se necessário */
</style>
